<template>
    <div id="visual-select-container">
        <VueSelect
            label="name"
            v-bind="$attrs" 
            :options="visuals" 
            @input="val => $emit('input', val)"
        >
            <template #option="visual">
                <span style="font-size: large">
                    <img width="160" :src="visual.data_url"/>
                    {{ visual.name }}
                </span>
            </template>
            <template #selected-option="visual">
                <span :title="visual.name">
                    <i class="fa-solid fa-circle" :style="{ color: visual.background_color }"></i>
                    {{ visual.name }}
                </span>
                <button type="button" class="btn btn-sm border mx-3" @mousedown.stop @click.stop="() => showVisualPreview(visual)">View</button>
            </template>
        </VueSelect>
        <Modal modal_id="previewVisualModal">
            <template #title>
                Preview Visual
            </template>
            <template #body>
                <AdvancedVisualPreview v-if="selected_visual" :advanced_visual="selected_visual" />
                <button type="button" class="btn btn-hub-primary my-2" @click="hideVisualPreview">Close</button>
            </template>
        </Modal>
    </div>
</template>

<script>
import { VueSelect } from 'vue-select';
import AdvancedVisualPreview from './AdvancedVisualPreview.vue'
import Modal from '../Modal.vue';

export default {
    inheritAttrs: false,
    components: { VueSelect, AdvancedVisualPreview, Modal },
    emits: ['input'],
    props: {
        visuals: Array,
    },
    data () {
        return {
            selected_visual: null
        }
    },
    methods: {
        showVisualPreview(visual) {
            this.selected_visual = visual
            $('#previewVisualModal').modal('show') // eslint-disable-line
        },
        hideVisualPreview() {
            $('#previewVisualModal').modal('hide') // eslint-disable-line
        }
    }
}
</script>

<style scoped>
</style>